export default __webpack_public_path__ + "static/media/car.c5350059.svg";